module.exports = __webpack_public_path__ + "static/media/logo.4f6d7b90.png";